export const getSubdomain = () => window.location.host.split('.')[0]

export const getBaseURL = project => envsBaseUrl[project][env]

const env = process.env.REACT_APP_API || 'development'

const subdomain = getSubdomain()

const envsBaseUrl = {
  recurrence: {
    development: `https://${subdomain}.yapay.net.br/api`,
    test: `https://${subdomain}.recorrencia-api-teste.yapay.net.br/api`,
    sandbox: `https://${subdomain}.recorrencia-api-sandbox.yapay.com.br/api`,
    production: `https://${subdomain}.recorrencia-api.yapay.com.br/api`,
  },
  recurrenceLegacyPortal: {
    development: `https://${subdomain}.yapay.net.br`,
    test: `https://${subdomain}.assinaturas.teste.yapay.net.br`,
    sandbox: `https://${subdomain}.assinaturas.sandbox.yapay.com.br`,
    production: `https://${subdomain}.assinaturas.yapay.com.br`,
  },
}

export default { getSubdomain, getBaseURL }
